export default "__VITE_ASSET__D0XRyU_J__"